
import { motion } from 'framer-motion';

export const StudentsVisuals = () => {
    return (
        <div className="w-full h-full bg-white relative overflow-hidden flex flex-col items-center justify-center p-8 font-jakarta">
            <div className="relative w-full max-w-[480px] aspect-[4/3]">

                {/* Laptop / Screen Frame */}
                <div className="absolute inset-0 bg-[#1e293b] rounded-2xl p-1.5 shadow-[0_25px_50px_-12px_rgba(0,0,0,0.25)] z-10 ring-1 ring-white/10">
                    <div className="w-full h-full bg-white rounded-xl overflow-hidden relative border border-gray-100 flex flex-col">

                        {/* Header Bar */}
                        <div className="h-8 bg-gray-50 border-b border-gray-100 flex items-center px-4 gap-2 justify-between">
                            <div className="flex gap-1.5">
                                <div className="w-2.5 h-2.5 rounded-full bg-red-400" />
                                <div className="w-2.5 h-2.5 rounded-full bg-yellow-400" />
                                <div className="w-2.5 h-2.5 rounded-full bg-green-400" />
                            </div>
                            <div className="text-[10px] text-gray-400 font-medium bg-white px-2 py-0.5 rounded border border-gray-200">
                                Final_Project_Presentation.deck
                            </div>
                        </div>

                        {/* Slide Content */}
                        <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ duration: 1 }}
                            className="flex-1 bg-white relative p-8 flex flex-col items-center text-center"
                        >
                            {/* Content Pattern */}
                            <div className="absolute inset-0 opacity-[0.03] bg-[radial-gradient(#2563EB_1px,transparent_1px)] bg-[size:20px_20px]" />

                            <div className="relative z-10 flex flex-col items-center justify-center h-full space-y-4">
                                <motion.div
                                    initial={{ scale: 0.8, opacity: 0 }}
                                    animate={{ scale: 1, opacity: 1 }}
                                    transition={{ delay: 0.5 }}
                                    className="w-24 h-24 bg-gradient-to-tr from-blue-500 to-indigo-600 rounded-2xl shadow-lg flex items-center justify-center transform rotate-3"
                                >
                                    <svg className="w-12 h-12 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" /></svg>
                                </motion.div>

                                <div className="space-y-1">
                                    <h2 className="text-2xl font-black text-gray-900 tracking-tight">The Future of AI</h2>
                                    <p className="text-xs text-gray-500 font-medium uppercase tracking-wide">Marketing 101 • Fall Semester</p>
                                </div>

                                <div className="flex gap-2 mt-4">
                                    <div className="w-8 h-8 rounded-full bg-gray-100 border-2 border-white shadow-sm overflow-hidden" >
                                        <img src={`https://api.dicebear.com/7.x/avataaars/svg?seed=Felix`} alt="avatar" className="w-full h-full" />
                                    </div>
                                    <div className="w-8 h-8 rounded-full bg-gray-100 border-2 border-white shadow-sm overflow-hidden -ml-4" >
                                        <img src={`https://api.dicebear.com/7.x/avataaars/svg?seed=Aneka`} alt="avatar" className="w-full h-full" />
                                    </div>
                                    <div className="w-8 h-8 rounded-full bg-gray-100 border-2 border-white shadow-sm flex items-center justify-center text-[10px] font-bold text-gray-500 bg-white -ml-4">
                                        +2
                                    </div>
                                </div>
                            </div>

                            {/* Bottom Controls */}
                            <div className="absolute bottom-4 left-0 right-0 flex justify-center gap-2">
                                {[1, 2, 3, 4].map(i => (
                                    <div key={i} className={`w-1.5 h-1.5 rounded-full ${i === 1 ? 'bg-blue-600' : 'bg-gray-200'}`} />
                                ))}
                            </div>
                        </motion.div>
                    </div>
                </div>

                {/* Sticker Element */}
                <motion.div
                    initial={{ scale: 0, rotate: 0 }}
                    animate={{ scale: 1, rotate: -15 }}
                    transition={{ delay: 1.5, type: "spring" }}
                    className="absolute -top-8 -left-8 z-20 w-24 h-24 bg-[#fbbf24] rounded-full flex items-center justify-center shadow-xl border-4 border-white transform hover:scale-110 transition-transform cursor-pointer"
                >
                    <div className="text-center transform rotate-6">
                        <span className="block text-4xl font-black text-yellow-950 leading-none">A+</span>
                        <span className="block text-[10px] font-bold text-yellow-800 uppercase tracking-widest leading-none mt-1">Grade</span>
                    </div>
                </motion.div>
            </div>
        </div>
    );
};
